import React from "react";
import { Box } from "@mui/material";
import attendance from "../../../assets/home/sidebar/attendance.png";
const Attendance = () => {
  return (
    <>
      <Box className="slidebar-container  br-16" marginTop="20px">
        <Box
          className="balance-container d-flex"
          gap="20px"
          paddingBottom="10px"
        >
          <div className="balance-logo flex-center-center">
            <img src={attendance} />
          </div>
          <h2>Attendance</h2>
        </Box>

        <Box className="d-flex">
          <h4 className="check">Last Check In: </h4>
          <h4 className="time"> 08:03</h4>
        </Box>
        <Box className="d-flex" paddingTop="10" gap="10">
          <h4 className="check">Last Check Out: </h4>
          <h4 className="time2"> 08:03</h4>
        </Box>
        <Box className="flex-center-center stopwatch">
          <h3>00:00:00</h3>
        </Box>
        <div className="button-blnc flex-center-center">
          <button className="balance-button">Request Time Off</button>
        </div>
      </Box>
    </>
  );
};

export default Attendance;
